/** What a reply's mail did, in one line under it (M3; moved out of the ticket page in M9 round three, pure): "sent 10:42", "bounced: …",
 *  "held: …" with the page's words for why it waits; nothing while it is queued. */
export function deliveryLine(d: { state: string; at: string | null; reason: string | null } | null | undefined, heldWords: Record<string, string>): string | undefined {
  if (!d || d.state === "queued") return undefined;
  const when = d.at ? new Date(d.at).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" }) : "";
  if (d.state === "sending") return "sending";
  if (d.state === "sent") return `sent ${when}`.trim();
  if (d.state === "delivered") return `sent · delivered ${when}`.trim();
  if (d.state === "bounced") return `bounced${d.reason ? `: ${d.reason}` : ""}`;
  if (d.state === "failed") return `not delivered${d.reason ? `: ${d.reason}` : ""}`;
  if (d.state === "held") return `held${d.reason ? `: ${heldWords[d.reason] ?? d.reason}` : ""}`;
  return d.state;
}

/** A forum reply's copy mail, as the team reads it under the reply (the To line round, 2026-10-30; pure): "Copy mailed to it@… · Bcc boss@…";
 *  the Bcc part only with blind copies (the thread is team-only), nothing without a copy */
export function copyLine(copy: { to: readonly string[]; bcc: readonly string[] } | null | undefined): string | undefined {
  if (!copy || (!copy.to.length && !copy.bcc.length)) return undefined;
  return [copy.to.length ? `Copy mailed to ${copy.to.join(", ")}` : "Copy mailed", copy.bcc.length ? `Bcc ${copy.bcc.join(", ")}` : null].filter(Boolean).join(" · ");
}

/** the words of a skipped answer mail's reason (the forum reply mails round, 2026-11-03) */
const ANSWER_SKIPPED: Record<string, string> = {
  suppressed: "the address cannot be written to",
  no_reply: "it is a no-reply address",
  team_member: "it is a team member's address",
  allowance: "today's allowance of new addresses is used",
};
/** A forum customer's answer mail, as the team reads it under the reply it announces (the forum reply mails round, 2026-11-03; pure):
 *  "Answer mailed to ada@…" while it waits or went, "Answer to … bounced / not delivered / held", "Answer not mailed: <why>"; nothing without one */
export function answerLine(answer: { to: string; state: string; reason: string | null } | null | undefined): string | undefined {
  if (!answer) return undefined;
  if (answer.state === "bounced") return `Answer to ${answer.to} bounced`;
  if (answer.state === "failed") return `Answer to ${answer.to} not delivered`;
  if (answer.state === "held") return `Answer to ${answer.to} held`;
  if (answer.state === "skipped") return `Answer not mailed: ${ANSWER_SKIPPED[answer.reason ?? ""] ?? "it could not be sent"}`;
  return `Answer mailed to ${answer.to}`;
}
